
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import Popup from 'vux/src/components/popup/index.vue'

import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "select-supply",
components: {
Popup,
CheckIcon,
XTable,

},
data() {
return {
value: null,
list: [],
show: false,
showBottom: false,
page: 0,
chooseData:null
}
},





props:['url','searchCondition','item','multiple','searchBaseData', 'noPage'],
methods: {

showPop() {
this.show = true;
document.body.style.overflow='hidden';
if(this.show){
this.page = 0;
this.showBottom = false;
this.value = null;
this.list = [];
this.chooseData = null;
this.getList();
}
},
getList() {
let searchData = {page: this.page, size: 10};
if(this.noPage){
this.searchBaseData[this.searchCondition['value']]=this.value;
} else {
searchData[this.searchCondition['value']]=this.value;
}
this.$search(this.url,searchData,this.searchBaseData).then(data => {
this.list = this.list.concat(data);
if(data.length < 10){
this.showBottom = true;
}else {
this.showBottom = false;
}
})
},
getMore(){
this.page++;
this.getList();
},

searchList(){
this.page = 0;
this.list = [];
this.chooseData = null;
this.getList();
},

choose(data){
if(this.multiple){
if(data.checkSelected){
if(!this.chooseData){
this.chooseData = [];
}
this.chooseData.push(data);
}else{
let dataList = [];
for(let i=0;i<this.chooseData.length;i++){
if(data.id !== this.chooseData[i].id){
dataList.push(this.chooseData[i]);
}
}
this.chooseData = dataList;
}
}else{
if(data.checkSelected){
if(this.chooseData){
this.$set(this.chooseData,'checkSelected',false);
}
this.chooseData = data;
}else{
this.chooseData = null;
}
}
},

goBack(){
document.body.style.overflow='auto';
if(this.multiple){
if(!this.chooseData || !this.chooseData.length){
this.$vux.toast.text('请选择数据');
return;
}
}else{
if(!this.chooseData){
this.$vux.toast.text('请选择数据');
return;
}
}
this.$emit('getChoosed',this.chooseData)
this.show=!this.show;
},
hide(){
document.body.style.overflow='auto';
}
}
}



// WEBPACK FOOTER //
// ./src/components/browse/select-supply.vue